import React from 'react';
import styled from 'styled-components';

const FooterContainer = styled.div`
  background: transparent;
  color: #495057;
  padding: 20px 40px;
  margin-top: auto;
`;

const FooterWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 1400px;
  margin: 0 auto;
`;

const FooterText = styled.div`
  font-size: 14px;
  color: #495057;
  text-align: center;
`;

const CrmXFooter: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <FooterContainer>
      <FooterWrapper>
        <FooterText>
          © 2022-2025 Smallize Pty Ltd. All rights reserved.
        </FooterText>
      </FooterWrapper>
    </FooterContainer>
  );
};

export default CrmXFooter;
